import { render, staticRenderFns } from "./ForumPage.vue?vue&type=template&id=64944e5e&scoped=true"
import script from "./ForumPage.vue?vue&type=script&lang=js"
export * from "./ForumPage.vue?vue&type=script&lang=js"
import style0 from "./ForumPage.vue?vue&type=style&index=0&id=64944e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64944e5e",
  null
  
)

export default component.exports